export enum MatchResultEnum {
  HOME_WIN = 'home_win',
  DRAW = 'draw',
  AWAY_WIN = 'away_win',
}